import { render, staticRenderFns } from "./water.vue?vue&type=template&id=ddf4a7c0&scoped=true&"
import script from "./water.vue?vue&type=script&lang=js&"
export * from "./water.vue?vue&type=script&lang=js&"
import style0 from "./water.vue?vue&type=style&index=0&id=ddf4a7c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf4a7c0",
  null
  
)

export default component.exports